__turbopack_context__.v({
  "status": "status-module-scss-module__yNdcNq__status",
});
